var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmountSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#2a62c8",
    height: "235px",
    width: "235px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 226 226",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    enableBackground: "new 0 0 226 226",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M210.12,39.812L115.688,0.537c-1.721-0.716-3.655-0.716-5.376,0L15.88,39.812c-2.611,1.086-4.312,3.636-4.312,6.463V219 c0,3.866,3.134,7,7,7h188.864c3.866,0,7-3.134,7-7V46.276C214.432,43.448,212.731,40.898,210.12,39.812z M200.432,212H25.568 V50.946L113,14.582l87.432,36.364V212z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.94,95.529l-29.667,29.667c-2.734,2.734-2.734,7.166 0,9.899 1.367,1.367 3.158,2.05 4.95,2.05s3.583-0.684 4.95-2.05l29.667-29.667c5.019-5.019 12.952-5.422 18.455-0.936 11.09,9.042 27.083,8.23 37.201-1.887l24.283-24.283v7.907c0,3.866 3.134,7 7,7s7-3.134 7-7v-24.703c0-3.866-3.134-7-7-7h-24.703c-3.866,0-7,3.134-7,7s3.134,7 7,7h7.7l-24.18,24.18c-5.019,5.019-12.954,5.422-18.455,0.937-11.09-9.044-27.083-8.233-37.201,1.886z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.256,150.711c0,3.866 3.134,7 7,7h141.487c3.866,0 7-3.134 7-7s-3.134-7-7-7h-141.487c-3.866,0-7,3.133-7,7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.744,164.139h-141.488c-3.866,0-7,3.134-7,7s3.134,7 7,7h141.487c3.866,0 7-3.134 7-7s-3.133-7-6.999-7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.744,184.567h-141.488c-3.866,0-7,3.134-7,7s3.134,7 7,7h141.487c3.866,0 7-3.134 7-7s-3.133-7-6.999-7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmountSvgrepoCom);
export default __webpack_public_path__ + "static/media/amount-svgrepo-com.3f6a09ef4de13b3468049bd03f20562d.svg";
export { ForwardRef as ReactComponent };